import { render, staticRenderFns } from "./AdminTaxonomiesView.vue?vue&type=template&id=90ab602c"
import script from "./AdminTaxonomiesView.vue?vue&type=script&lang=ts"
export * from "./AdminTaxonomiesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports